export default __webpack_public_path__ + "static/media/Credit Card Payment-cuate.58fa9475.svg";